var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.weapons,"items-per-page":_vm.weapons.length,"sort-by":"dps.average","sort-desc":true,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }